import { CHECKLIST_SECTIONS } from "./checklist-config.ts";
import type { ChecklistSection } from "./checklist-section.ts";

class ChecklistContainer extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  private render() {
    this.innerHTML = '<div class="space-y-6 w-full min-w-0"></div>';
    const wrapper = this.querySelector("div")!;

    for (const sectionConfig of CHECKLIST_SECTIONS) {
      const el = document.createElement("checklist-section") as
        & ChecklistSection
        & HTMLElement;
      wrapper.appendChild(el);
      (el as unknown as ChecklistSection).setConfig(sectionConfig);
    }
  }
}

customElements.define("checklist-container", ChecklistContainer);
